import React, { useContext } from 'react';

import { MenuItem } from '@mui/material';
import moment from 'moment';
import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';
import Select from '../forms/Select';

const StyledSelect = styled(Select)`
    min-width: 250px;
`;

export interface ClassSessionSelectProps {
    onChange: (e) => void;
}

const ClassSessionSelect: React.FC<ClassSessionSelectProps> = ({ onChange }) => {
    const { t, sessions, classSessionId } = useContext(AttendanceContext);

    if (!classSessionId) return null;

    const renderOptions = () => {
        const now = new Date();

        return sessions.map((session) => {
            const start = new Date(session.start_time);
            const end = new Date(session.end_time);

            if (start < now && end > now) {
                return (
                    <MenuItem key={session.session_id} value={session.session_id}>
                        {t('today')}
                    </MenuItem>
                );
            }

            return (
                <MenuItem key={session.session_id} value={session.session_id}>
                    {moment(session.start_time).format('L')}
                    {' - '}
                    {t(moment(session.start_time).format('dddd').toLowerCase())}
                    {' - '}
                    {moment(session.start_time).format('h:mm A')}
                </MenuItem>
            );
        });
    };

    return (
        <StyledSelect defaultValue={classSessionId} value={classSessionId} name={'class-session'} onChange={onChange}>
            <MenuItem key={0} value={'session-summary'}>
                {t('session-summary')}
            </MenuItem>
            <MenuItem key={1} value={'student-summary'}>
                {t('student-summary')}
            </MenuItem>
            {renderOptions()}
        </StyledSelect>
    );
};

export default ClassSessionSelect;
